import { useEffect } from "react";

/**
 * Bloquea el scroll del body mientras el modal está abierto.
 * Previene el bucle infinito cuando el teclado móvil abre dentro
 * de un modal con position: fixed.
 */
export function useScrollLock(isOpen) {
  useEffect(() => {
    if (!isOpen) return;

    const scrollY = window.scrollY;
    document.body.classList.add("scroll-locked");
    document.body.style.top = `-${scrollY}px`;

    return () => {
      document.body.classList.remove("scroll-locked");
      document.body.style.top = "";
      window.scrollTo(0, scrollY);
    };
  }, [isOpen]);
}
